import { SAVEUSERINFO } from '../constact'

const saveUserInfo = data => ({
    type: SAVEUSERINFO,
    data
})
export default saveUserInfo;